import { useState, useEffect, useRef } from "react";
import { Link, NavLink, Navigate, useNavigate } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";

import { ToastContainer, toast, Zoom } from "react-toastify";
import {
  updateSession,
  loaderBar,
  apibaseURl,
  currencySymbol,
  errorToast,
  successToast,
  loggedInCustomerDetails,
  getvalidationErr,
} from "../../../functions/Function";

const StepSeven = ({
  inputs,
  setInputs,
  updateorderId,
  setupdateorderId,
  handleCreateOrder,
  props
}) => {
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);
  const targetRef = useRef();
  const [terms, setTerms] = useState([]);
  const [grandtotal, setGrandtotal] = useState(0.0);
  const [dimensions, setDimensions] = useState(300);
  const [totalcheckbox, settotalcheckbox] = useState("No");
  const inputElement = useRef({});

  const checkbox = useRef();

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };


  const clear = () => {
    inputElement.current.clear();
    setInputs((values) => ({ ...values, signature: "" }));
  };

  const trim = () => {
    if (inputElement.current.getSignaturePad().isEmpty() == false) {
      setInputs((values) => ({
        ...values,
        signature: inputElement.current
          .getTrimmedCanvas()
          .toDataURL("image/png"),
      }));
    }
  };



  const handleOrderSubmit = async () => {
    setDisabled(true);
    const isValid = handleCreateOrder();
    if (!isValid) {
      setDisabled(false);
      return;
    }

    try {
      let res = await fetch(apibaseURl + "addOrder", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(inputs),
      });
      let output = await res.json();
      if (res.status === 200) {
        setDisabled(false);
        if (output.result == true) {
          navigate('/OrderSuccess')
        } else {
          if (output.validation == true) {
            errorToast(getvalidationErr(output.response), "top-right", "6000");
          } else {
            errorToast(output.msg, "top-right", "6000");
          }
        }
      }
    } catch (err) {
      setDisabled(false);
    }
  };


  const handleOrderUpdate = async () => {
    setDisabled(true);
    const isValid = handleCreateOrder();
    if (!isValid) {
      setDisabled(false);
      return;
    }

    try {
      let res = await fetch(apibaseURl + "updateOrder", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...inputs, order_id: props.updateorderId }),
      });
      let output = await res.json();


      if (res.status === 200) {
        setDisabled(false);
        if (output.result == true) {
          successToast(output.msg, "top-right", "6000");
          navigate("/orders");
        } else {
          if (output.validation == true) {
            errorToast(getvalidationErr(output.response), "top-right", "6000");
          } else {
            errorToast(output.msg, "top-right", "6000");
          }
        }
      }
    } catch (err) {
      setDisabled(false);
    }
  };



  const checkedSizeCheckbox = (event) => {
    const { name, checked } = event.target;

    setInputs((values) => ({
      ...values,
      [name]: checked ? "accept" : ""
    }));
  }
  const getTerms = async () => {
    let res = await fetch(apibaseURl + "getTerms");
    let output = await res.json();
    if (res.status === 200) {
      if (output.result == true) {
        setTerms(output.response);

      }
    }
  };



  const totalPriceOfdisplayCustomization = () => {
    const sum = inputs.display.reduce(
      (acc, item) => acc + parseFloat(item.price),
      0
    );
    const formattedSum = sum.toFixed(2);
    return formattedSum;
  };

  useEffect(() => {


    // addional chages ke liey 
    const grandTotalforAddionalcharges = inputs.additional_charges.reduce(
      (sum, item) => sum + parseFloat(item.total || 0),
      0
    );
    // inputs.display_types customazion ke lieye 
    let total = inputs.display_types.reduce((sum, item) => {
      const qty = parseFloat(item.qty || 0);
      const price = parseFloat(item.display_type_metal_price || 0);
      return sum + qty * price;
    }, 0);

    if (inputs.display_types.every((item) => parseFloat(item.qty || 0) === 0)) {
      total = 0;
    }

    let totalOfdisplayCustomization = totalPriceOfdisplayCustomization();

    let totalMagnets = 0;

    if (inputs.order_type_magnet === "Magnets" && inputs.displaytype_magnet_option === "Magnet_only") {
      totalMagnets = (inputs.display_magnet || []).reduce((acc, item) => {
        return acc + parseFloat(item.price || 0);
      }, 0);

    } else if (inputs.order_type_magnet === "Magnets" && inputs.displaytype_magnet_option === "display_design") {
      totalMagnets = (inputs.display_types_magnet || []).reduce((sum, item) => {
        const qty = parseFloat(item.qty || 0);
        const price = parseFloat(item.display_type_metal_price || 0);
        return sum + qty * price;
      }, 0);

    } else {
      totalMagnets = 0;
    }

    let totalprice = 0;
    if (inputs.displaytype === "Sticker_only") {
      totalprice = parseFloat(totalOfdisplayCustomization) + totalMagnets + grandTotalforAddionalcharges;
    } else if (inputs.displaytype === "display_design") {
      totalprice = parseFloat(total)  + totalMagnets + grandTotalforAddionalcharges;
    } else if (inputs.displaytype === "display_by_keyword") {
      totalprice = parseFloat(total) + totalMagnets + grandTotalforAddionalcharges;
    } else {
      totalprice = parseFloat(total) + parseFloat(totalOfdisplayCustomization) + totalMagnets + grandTotalforAddionalcharges;
    }
    setInputs((values) => ({ ...values, total: totalprice }));
    calculatePercentage(totalprice);
  }, [
    inputs.displaytype,
    inputs.order_type_magnet,
    inputs.discount_percentage,
    inputs.order_type,
    inputs.displaytype_magnet_option,
    JSON.stringify(inputs.display_types),
    JSON.stringify(inputs.display_types_magnet),
    JSON.stringify(inputs.display),
    JSON.stringify(inputs.display_magnet),
    JSON.stringify(inputs.additional_charges),
  ]);

  const calculatePercentage = (toalamount) => {
    const discountAmount = ((toalamount * inputs.discount_percentage) / 100).toFixed(2);
    const finalAmount = (toalamount - discountAmount).toFixed(2);

    setInputs((values) => ({
      ...values,
      discount: parseFloat(discountAmount),
    }));
    setGrandtotal(finalAmount);

  };

  useEffect(() => {
    getTerms();
  }, [inputs.discount_percentage]);

  useEffect(() => {
    getTerms();
    if (targetRef.current) {
      setDimensions(targetRef.current.offsetWidth);
    }
  }, []);

  const updatediscountpercentage = (percentage) => {
    if (percentage >= 0) {
      setInputs((values) => ({
        ...values,
        discount_percentage: percentage,
      }));
    }
  };

  const checkedTotalCheckbox = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    if (value == "Yes") {
      settotalcheckbox("No");
    } else {
      settotalcheckbox("Yes");
    }
  };

  return (
    <>
      <ToastContainer />
      <section className="section order-detail-2">
        <div className="container">
          <div className="row">
            <div className="col-lg-12  inner-display-box-checks progress-bar-box">
              <div className="row">
                <div className="col-lg-12 col-sm-12 ">
                  <div className="text-center">
                    <h5>TERMS AND CONDITIONS</h5>
                  </div>
                  <div className="input-digits-box mt-4 overflow">
                    <div className="text-box">
                      {terms.length > 0 &&
                        terms.map((term, i) => (
                          <p>
                            {i + 1}. {term}
                          </p>
                        ))}
                    </div>

      
                    <div className="form-check check-box termsbox">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="terms_and_conditions"
                        value="accept"
                        onChange={checkedSizeCheckbox}
                      />
                      <label className="form-check-label" htmlFor="flexRadioDefault2">
                        I have read and agree to the website terms and conditions
                      </label>
                    </div>

                    <div className="input-digits-box mt-4 overflow">
                      <div className="form-text-area-6">
                        <div className="mb-3 form-input-box ">
                          <label className="form-label">
                            <h5>Additional Notes</h5>
                          </label>
                          <div className="form-input-box">
                            <textarea
                              className="form-control"
                              rows="6"
                              name="note"
                              value={inputs.note || ""}
                              onChange={handleChange}
                              placeholder="Additional Note"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="price-input">
                      <div className="row g-3 needs-validation">
                        <div className="col-lg-12">
                          <div className="price-label-box">
                            <label className="form-label">Total</label>
                            <div className={`input-group has-validation ${totalcheckbox === "Yes" ? "gray-border" : "blue-border"}`}>
                              <span
                                className={totalcheckbox === "Yes" ? 'input-group-text_wrape' : 'input-group-text'}
                                id="inputGroupPrepend"
                              >
                                $
                              </span>

                              <input
                                type="number"
                                name="total"
                                value={
                                  parseFloat(inputs.total).toFixed(2) || ""
                                }
                                className="form-control"
                                readOnly={true}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="price-label-box">
                            <label className="form-label">Discount</label>
                            <div className={`input-group has-validation ${totalcheckbox === "Yes" ? "gray-border" : "blue-border"}`}>
                              <span
                                className={totalcheckbox === "Yes" ? 'input-group-text_wrape' : 'input-group-text'}
                                id="inputGroupPrepend"
                              >
                                In (%)
                              </span>

                              <input
                                type="number"
                                name="discount_percentage"
                                value={Number(inputs.discount_percentage) || ""}
                                onChange={(e) =>
                                  updatediscountpercentage(e.target.value)
                                }
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-12 d-flex justify-content-center align-items-center">
                          <div className="price-label-box">
                            <label className="form-label">Grand Total</label>
                            <div className={`input-group has-validation ${totalcheckbox === "Yes" ? "gray-border" : "blue-border"}`}>
                              <span
                                className={totalcheckbox === "Yes" ? 'input-group-text_wrape' : 'input-group-text'}
                                id="inputGroupPrepend"
                              >
                                $
                              </span>

                              <input
                                type="number"
                                name="ua"
                                value={grandtotal}
                                className="form-control"
                                readOnly={true}
                              />
                            </div>
                          </div>
                          <input
                            className="form-check-input"
                            type="radio"
                            name=""
                            value={totalcheckbox}
                            checked={totalcheckbox === "Yes"}
                            onClick={checkedTotalCheckbox}
                          />
                        </div>


                        {totalcheckbox === "Yes" && (
                          <div className="col-lg-12">
                            <div className="price-label-box">
                              <label className="form-label">
                                Adjusted Total Order Value
                              </label>
                              <div className="input-group has-validation blue-border">
                                <span
                                  className="input-group-text"
                                  id="inputGroupPrepends"
                                >
                                  $
                                </span>

                                <input
                                  type="number"
                                  name="override_total"
                                  value={inputs.override_total || ""}
                                  onChange={handleChange}
                                  className="form-control"
                                />
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="sign-here-box">
                          <h6>Sign Here</h6>
                          {inputs.signature == "" && (
                            <>
                              <div className="sign-heres" ref={targetRef}>
                                <SignatureCanvas
                                  setInputs={setInputs}
                                  penColor="black"
                                  canvasProps={{
                                    width: dimensions,
                                    height: 200,
                                    className: "sigCanvas sign-here",
                                  }}
                                  ref={inputElement}
                                />
                              </div>
                              <div className="text-center mt-4 signbutton">
                                <button
                                  className="btn btn-success btn-sm"
                                  onClick={trim}
                                >
                                  Save signature
                                </button>
                                &nbsp; &nbsp; &nbsp;
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={clear}
                                >
                                  Clear signature
                                </button>
                              </div>
                            </>
                          )}

                          {inputs.signature && (
                            <div className="sign-heres">
                              <div className="sign-here signature">
                                <img src={inputs.signature} />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="text-center">
                  <button
                    onClick={props.updateorderId ? handleOrderUpdate : handleOrderSubmit}
                    className="btn site-btn"
                    disabled={disabled}
                  >
                    Submit Order
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default StepSeven;
